<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :before-close="handleClose"
  >
    <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
      <div>图片备注</div>
    </div>
    <div class="bj">
      <div class="descdetail" v-for="(e,i) in messageList" :key="i">
        <div class="head">
          <div class="left">
            <img src="@/assets/sreenpic/user.png" alt />
            <p>{{e.createUserName}}</p>
          </div>
          <div class="right">{{e.createAtMy}}</div>
        </div>

        <div class="body">{{e.message}}</div>
      </div>

      <template>
        <div class="nonr" v-if="messageList.length === 0">
          <img src="@/assets/piclist/nonr.png" alt="">
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    messageList:{
        type:Array
    },
    dialogVisible: Boolean,
  },
  watch: {
    dialogVisible: {
      deep: true,
      handler(v) {
        this.dialogVisible = v;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
/deep/ .el-dialog__header {
  height: 20px !important;
}
/deep/ .el-dialog__body{
  padding: 0 !important;
  ::-webkit-scrollbar {
    width: 8px;
    height: 32px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    height: 38px;
    /* 滚动条滑块长度 */
    background: rgba(24, 94, 212, 0.2);
  }
}
.bj {
  padding: 20px 20px 10px 20px;
  box-sizing: border-box;
  height: 500px;
  overflow-y: auto;
  
}
.nonr{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.descdetail {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  // height: auto;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background: #f1f1f1;
  margin-bottom: 20px;
  .head {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    .left {
      color: #333333;
      display: flex;
      align-items: center;
      p {
        margin-left: 10px;
      }
    }
    .right {
      color: #666666;
    }
  }
  .body {
    margin-top: 10px;
    color: #979797;
  }
}
</style>